import { render } from "./simpleselect.vue?vue&type=template&id=458eda17&scoped=true"
import script from "./simpleselect.vue?vue&type=script&lang=js"
export * from "./simpleselect.vue?vue&type=script&lang=js"

import "./simpleselect.vue?vue&type=style&index=0&id=458eda17&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458eda17"]])

export default __exports__